import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { coinApi } from "../../api/coin-api";
import TopBar from "../../components/topBar";
import { getText } from "../../utils/util";
import CenterPage from "./components/centerPage";
// import C2CCKTS from "./components/c2cckts";
// import C2CCKTS2 from "./components/c2cckts2";
import { AcendexLayout } from "@/components/acendex/components/layout/AcendexLayout";
import { isMobile } from "react-device-detect";

export default function RechargeList() {
  const navigate = useNavigate();
  const uid = localStorage.getItem("uid");
  const { t: translate } = useTranslation();
  const [coinList, setCoinList] = useState([] as any[]);
  //加载种类
  const loadCoinData = async () => {
    const data = await coinApi.list();
    if (data.ok) {
      //排序
      data.data.sort(function (a, b) {
        return a.sort - b.sort;
      });
      setCoinList(data.data);
    }
  };

  useEffect(() => {
    loadCoinData();
  }, []);
  return (
    <div className="revert-style flex flex-col w-full bg-neutral-900 text-neutral-200 min-h-screen">
      <AcendexLayout
        theme="light"
        hideBottomBar
        pcTopBarTitle={translate(getText("入金"))}
        mobileTopBarTitle={translate(getText("入金"))}
        topBarRightContent={
          <div className="flex items-center gap-2">
            <div
              className="text-neutral-200"
              onClick={() => {
                navigate("/rechargeorderlist");
              }}
            >
              {translate(getText("充值明细"))}
            </div>
          </div>
        }
      >
        <CenterPage coinList={coinList} />
      </AcendexLayout>
    </div>
  );
}
